module.exports = {"accessToken":"pk.eyJ1Ijoic3ZvaG9uZyIsImEiOiJjam50cWZvNTcwd2hnM3dvYWZ0cXNmaXd5In0.EGW7S9zxEGpyNSWJ6gTh3Q"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/json-resources/mapbox-config.json
// module id = yPUY
// module chunks = 0